module.exports = __webpack_public_path__ + "img/caffeine_logo.6c6f71ef.png";